






































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
    getMenuItemPicturesStorageRef,
    IMenuItem,
    MenuItem,
    MenuItemIngredient,
    MenuItemRequiredChoice,
    MenuItemSize
} from "@/data/MenuItem";
import {Prop, Ref} from "vue-property-decorator";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import ItemViewAndEditComponent from "@/components/ItemViewAndEditComponent.vue";
import EditableList from "@/components/EditableList.vue";
import {getAdditionalIngredientsGroupRef, IAdditionalIngredientsGroup} from "@/data/AdditionalIngredientsGroup";
import {
    DocumentOrRefMatch,
    DocumentRefMatch,
    matchRefsWithDocuments,
    RefDocumentMatch
} from "@/common/js/firestore-utils";
import CloudStorageImage from "@/components/CloudStorageImage.vue";
import EditableCloudStorageImageList from "@/components/EditableCloudStorageImageList.vue";
import {EditableListImage} from "@/components/EditableCloudStorageImageList";
import {randomString} from "@/common/js/utils";
import {storageFileExists} from "@/common/js/storage-utils";
import CloudStorageImageCarousel from "@/components/CloudStorageImageCarousel.vue";

@Component({
    components: {
        CloudStorageImageCarousel,
        EditableCloudStorageImageList,
        CloudStorageImage,
        EditableList,
        ItemViewAndEditComponent,
        ValidationProvider,
        ValidationObserver
    }
})
// @ts-ignore
export default class MenuItemComponent extends Vue {

    editedMenuItem: IMenuItem = new MenuItem().copy({});
    editedMenuItemUpdatedPictures: EditableListImage[] = [];

    @Ref() readonly picturesList!: EditableCloudStorageImageList;

    @Prop() readonly menuItem?: IMenuItem;
    @Prop() readonly providerId?: string;
    @Prop() readonly additionalIngredientsGroups?: IAdditionalIngredientsGroup[];
    @Prop({default: () => false}) readonly additionalIngredientsGroupsLoading?: boolean;

    @Prop() readonly onSave?: (editedMenuItem: IMenuItem) => Promise<void>;
    @Prop() readonly onDelete?: (menuItem: IMenuItem) => Promise<void>;

    @Prop() readonly onSaveError?: (error: any) => void;
    @Prop() readonly onDeleteError?: (error: any) => void;
    @Prop() readonly onCancel?: () => Promise<void>;

    @Prop() readonly creation?: boolean;

    get matchedAdditionalIngredientsGroups(): DocumentRefMatch<IAdditionalIngredientsGroup>[] {
        if (!this.additionalIngredientsGroups) return [];
        return this.additionalIngredientsGroups.map(group => ({
            id: group.id,
            document: group,
            ref: this.providerId ? getAdditionalIngredientsGroupRef(this.providerId, group.id) : null
        }));
    }

    get assignedAdditionalIngredientsGroups(): RefDocumentMatch<IAdditionalIngredientsGroup>[] {
        if (!this.menuItem) return [];
        return matchRefsWithDocuments(
            this.menuItem.assignedAdditionalIngredientsGroups,
            this.additionalIngredientsGroups || []
        );
    }

    get additionalIngredientsGroupsSelect(): DocumentOrRefMatch<IAdditionalIngredientsGroup>[] {
        const groups: DocumentOrRefMatch<IAdditionalIngredientsGroup>[] = this.matchedAdditionalIngredientsGroups.map(group => group);
        for (let editedGroup of this.editedAssignedAdditionalIngredientsGroups)
            if (!groups.find(group => group.id === editedGroup.id))
                groups.push(editedGroup);
        return groups;
    }

    get editedAssignedAdditionalIngredientsGroups(): RefDocumentMatch<IAdditionalIngredientsGroup>[] {
        return matchRefsWithDocuments(
            this.editedMenuItem.assignedAdditionalIngredientsGroups,
            this.additionalIngredientsGroups || []
        );
    }

    set editedAssignedAdditionalIngredientsGroups(groups: RefDocumentMatch<IAdditionalIngredientsGroup>[]) {
        this.editedMenuItem.assignedAdditionalIngredientsGroups = groups.map(group => group.ref);
    }

    async savePictures(menuItemId: string = this.editedMenuItem.id): Promise<string[]> {
        if (!this.providerId) return this.editedMenuItem.pictures;

        const providerImagesFolder = getMenuItemPicturesStorageRef(this.providerId, menuItemId);

        return await this.picturesList.syncToStorage(async (image) => {
            const imageExtension = image.file.name.split(".").pop();

            let imageRef;
            do {
                const name = `${randomString(8)}.${imageExtension}`;
                imageRef = providerImagesFolder.child(name);
            } while (await storageFileExists(imageRef));

            return imageRef;
        });
    }

    edit() {
        if (this.menuItem) {
            MenuItem.copy(this.menuItem, this.editedMenuItem);
        }
    }

    closeEdit() {
        new MenuItem().copy(this.editedMenuItem);
        this.editedMenuItemUpdatedPictures = [];
    }

    deleteMenuItem() {
        if (this.menuItem) this.onDelete?.(MenuItem.copy(this.menuItem, {}));
    }

    async save() {
        await this.onSave?.(MenuItem.copy(this.editedMenuItem, {}));
    }

    newIngredient() {
        return new MenuItemIngredient().copy({});
    }

    newSize() {
        return new MenuItemSize().copy({});
    }

    newRequiredChoice() {
        return new MenuItemRequiredChoice().copy({});
    }

    removeAdditionalIngredientsGroup(removedGroup: RefDocumentMatch<IAdditionalIngredientsGroup>) {
        this.editedMenuItem.assignedAdditionalIngredientsGroups = this.editedMenuItem.assignedAdditionalIngredientsGroups.filter(
            groupRef => groupRef.id !== removedGroup.id
        );
    }

    filterAdditionalIngredientsGroupsSelect(group: DocumentOrRefMatch<IAdditionalIngredientsGroup>, query: string) {
        query = query.toLocaleLowerCase();
        return group.document ?
            group.document.name.toLocaleLowerCase().includes(query) ||
            group.document.ingredients.some(ingredient => ingredient.name.toLocaleLowerCase().includes(query))
            : false;
    }

}
